import { createRequestActions } from '../utils';
import * as productTRTypes from './productTRTypes';

export const saveProductTRs = createRequestActions(productTRTypes.SAVE_PRODUCT_TRs);
export const listProductTR = createRequestActions(productTRTypes.PRODUCT_TR_LIST);
